import React from 'react';

/**
 * Reusable Info Row Component
 * Displays a label-value pair in a consistent format
 */
const InfoRow = ({ label, value, className = '' }) => (
    <div className={className}>
        <div className="text-xs uppercase tracking-wide text-gray-400">{label}</div>
        <div className="font-semibold text-white">{value || 'N/A'}</div>
    </div>
);

export default InfoRow;
